module.exports = __webpack_public_path__ + "static/media/forteljing.c6c45cad.m4a";